import React from "react";
import { Link } from "react-router-dom";
import NavBar from "./Navbar";
import FacultySectionNav from "./FacultySectionNav";
import { formatFacultyWorkspaceCourse } from "../utils/facultyWorkspace";

function FacultyDashboardShell({
  eyebrow,
  title,
  description,
  showTopbar = true,
  showWorkspaceBanner = false,
  message = "",
  error = "",
  loadingLabel = "",
  loading = false,
  workspaceCourse = null,
  workspaceMode = "all_courses",
  workspaceHint = "",
  nextActions = [],
  children,
}) {
  const hasTopbarContent = Boolean(eyebrow || title || description);
  const courseLabel = formatFacultyWorkspaceCourse(workspaceCourse);
  const isCourseSelected = Boolean(workspaceCourse?.courseId);

  return (
    <>
      <NavBar />
      <div className="faculty-page">
        <div className="faculty-shell">
          {showTopbar && hasTopbarContent && (
            <div className="faculty-topbar">
              <div className="faculty-topbar-copy">
                {eyebrow && <div className="faculty-eyebrow">{eyebrow}</div>}
                {title && <h1>{title}</h1>}
                {description && <p>{description}</p>}
              </div>
            </div>
          )}

          <FacultySectionNav />

          {showWorkspaceBanner && (
            <div className="faculty-workspace-banner faculty-workspace-banner-compact" aria-label="Faculty workspace context">
              <div className="faculty-workspace-banner-copy">
                <div className="faculty-eyebrow">Selected Course</div>
                <h2>{courseLabel}</h2>
                {workspaceHint && (
                  <p>
                    {workspaceMode === "selected_course"
                      ? workspaceHint
                      : workspaceHint}
                  </p>
                )}
              </div>
              <div className="faculty-workspace-banner-actions">
                <span className={`faculty-status-pill ${isCourseSelected ? "active" : "archived"}`}>
                  {isCourseSelected ? "Selected" : "No course selected"}
                </span>
                {nextActions.map((action) => (
                  <Link key={`${action.to}-${action.label}`} to={action.to} className="faculty-workspace-link">
                    {action.label}
                  </Link>
                ))}
              </div>
            </div>
          )}

          {message && <div className="alert alert-success mt-3" role="status">{message}</div>}
          {error && <div className="alert alert-warning mt-3" role="alert">{error}</div>}
          {loading && loadingLabel && <div className="faculty-empty-state" role="status">{loadingLabel}</div>}

          {children}
        </div>
      </div>
    </>
  );
}

export default FacultyDashboardShell;
